import { render } from "./staff_dashboard.vue?vue&type=template&id=5677c804&scoped=true"
import script from "./staff_dashboard.vue?vue&type=script&lang=js"
export * from "./staff_dashboard.vue?vue&type=script&lang=js"

import "./staff_dashboard.vue?vue&type=style&index=0&id=5677c804&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5677c804"]])

export default __exports__